export default __webpack_public_path__ + "static/media/Group 911.0680d658.svg";